import React from 'react'
import { LuCreditCard, LuRefreshCw, LuCalendar } from "react-icons/lu";
const PlanTypeSelector = ({ planType, onChange, disabled = false }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Plan Type</h3>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {/* Balance-Based Plan */}
        <div
          className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            } ${planType === 'BAL'
              ? 'border-[#604FF8] bg-[#e8ebfe]'
              : 'border-gray-200 hover:border-gray-300'
            }`}
          onClick={() => !disabled && onChange('BAL')}
        >
          <div className="flex items-start space-x-3">
            <div className={`p-2 rounded-lg ${planType === 'BAL' ? 'bg-[#e8ebfe]' : 'bg-gray-100'
              }`}>
              <LuCreditCard className={`h-5 w-5 ${planType === 'BAL' ? 'text-[#604FF8]' : 'text-gray-600'
                }`} />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  checked={planType === 'BAL'}
                  disabled={disabled}
                  onChange={() => onChange('BAL')}
                  className="h-4 w-4 accent-[#604FF8]"
                />
                <h4 className="font-medium text-gray-900">Balance-Based Plan</h4>
              </div>
              <p className="mt-1 text-sm text-gray-500">
                Create a payment plan to pay off an existing balance over time with scheduled payments.
              </p>
              <div className="mt-2 text-xs text-gray-400">
                Best for: Outstanding balances, treatment costs, copays
              </div>
            </div>
          </div>
        </div>

        {/* Subscription-Based Plan */}
        <div
          className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            } ${planType === 'SUB'
              ? 'border-[#604FF8] bg-[#e8ebfe]'
              : 'border-gray-200 hover:border-gray-300'
            }`}
          onClick={() => !disabled && onChange('SUB')}
        >
          <div className="flex items-start space-x-3">
            <div className={`p-2 rounded-lg ${planType === 'SUB' ? 'bg-[#e8ebfe]' : 'bg-gray-100'
              }`}>
              <LuRefreshCw className={`h-5 w-5 ${planType === 'SUB' ? 'text-[#604FF8]' : 'text-gray-600'
                }`} />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  checked={planType === 'SUB'}
                  disabled={disabled}
                  onChange={() => onChange('SUB')}
                  className="h-4 w-4 accent-[#604FF8]  "
                />
                <h4 className="font-medium text-gray-900">Subscription-Based Plan</h4>
              </div>
              <p className="mt-1 text-sm text-gray-500">
                Set up recurring payments for ongoing services, memberships, or treatment plans.
              </p>
              <div className="mt-2 text-xs text-gray-400">
                Best for: Monthly services, wellness plans, ongoing care
              </div>
            </div>
          </div>
        </div>

        {/* Pre-Treatment Plan */}
        {/* <div
          className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            } ${planType === 'pretreatment'
              ? 'border-[#604FF8] bg-[#e8ebfe]'
              : 'border-gray-200 hover:border-gray-300'
            }`}
          onClick={() => !disabled && onChange('pretreatment')}
        >
          <div className="flex items-start space-x-3">
            <div className={`p-2 rounded-lg ${planType === 'pretreatment' ? 'bg-[#e8ebfe]' : 'bg-gray-100'
              }`}>
              <LuCalendar className={`h-5 w-5 ${planType === 'pretreatment' ? 'text-[#604FF8]' : 'text-gray-600'
                }`} />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  checked={planType === 'pretreatment'}
                  disabled={disabled}
                  onChange={() => onChange('pretreatment')}
                  className="h-4 w-4 accent-[#604FF8]"
                />
                <h4 className="font-medium text-gray-900">Pre-Treatment Plan</h4>
              </div>
              <p className="mt-1 text-sm text-gray-500">
                Schedule payments for upcoming procedures or treatments with flexible installment options.
              </p>
              <div className="mt-2 text-xs text-gray-400">
                Best for: Elective procedures, cash-pay treatments, cosmetic services
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default PlanTypeSelector